import { useEffect, useState } from 'react';

import { useMessageStatsRequest } from './use_message_stats_request';
import { usePusher } from './use_pusher';

const PUSHER_CHANNEL_NAME = 'sms-info';
const PUSHER_CHANNEL_EVENT = 'sms-info-pending-count';

export const useSMSInboxCount = () => {
  const { response } = useMessageStatsRequest();
  const [count, setCount] = useState<number | undefined>(undefined);

  useEffect(() => {
    setCount(response?.data?.count);
  }, [response]);

  usePusher<{ count: number }>(PUSHER_CHANNEL_NAME, PUSHER_CHANNEL_EVENT, (data) => {
    setCount(data.count);
  });

  return count;
};
